module.exports = __webpack_public_path__ + "static/media/oberflex-chenenaturel-1200x2490.f8cf2326.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-chenenaturel-1200x2490.jpg
// module id = 988
// module chunks = 37